import gql from 'graphql-tag'

export default gql`
  query GetProduct($id: Int!) {
    product(id: $id) {
      id
      sku
      title
      description
      slug
      pageTitle
      metaDescription
      images {
        url
        description
      }
      customFields {
        name
        value
      }
      variants {
        image {
          url
          description
        }
        id
        price
        optionValues {
          id
          optionId
        }
      }
      options {
        id
        type
        displayName
        values {
          id
          label
        }
      }
      modifiers {
        id
        type
        displayName
        values {
          id
          label
        }
      }
      constraints {
        ... on GiftCardConstraints {
          minValue
          maxValue
          maxDeliveryDateMonths
        }
      }
    }
  }
`
